import { Panel, tokens } from '@cast/design-system';
import { PropsWithChildren } from 'react';

type BuilderPanelProps = PropsWithChildren<{
  testId?: string;
  hasError?: boolean;
}>;

export const BuilderPanel = ({
  hasError,
  children,
  testId,
}: BuilderPanelProps) => {
  return (
    <Panel
      sx={[
        {
          p: 16,
          backgroundColor: tokens.theme.bg.structural.surfaceRaised,
          border: hasError
            ? tokens.theme.border.status.error
            : tokens.theme.border.structural.neutral,
        },
      ]}
      testId={testId}
    >
      {children}
    </Panel>
  );
};
